import React from 'react';
import Switch from '@mui/material/Switch';

const SensorSettings = ({
  title,
  color,
  mod,
  settings,
  fieldConfig = {}
}) => {
  const switchFields = fieldConfig.switch || [];
  const textFields = fieldConfig.text || [];
  const selectFields = fieldConfig.select || [];
  const selectOptions = fieldConfig.selectOptions || {};
  
  return (
    <div
      className="settings-grid"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'flex-start',
        gap: '0.5em',
        borderWidth: '2px', 
        borderStyle: 'solid', 
        borderColor: color,
        marginTop: '1em',
        marginLeft: '1em' 
      }}
    >
      <div style={{ fontWeight: 'bold' }}>{title}</div>
      {Object.entries(settings).map(([field, [value, setter]]) => (
        <div
          key={field}
          className="setting-item"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: '1em',
          }}
        >
          <label style={{ minWidth: '160px', margin: 0 }}>{field}</label>

          {switchFields.includes(field) ? (
            <Switch
              disabled={mod === 0}
              checked={!!value}
              onClick={() => setter(!value)}
            />
          ) : selectFields.includes(field) ? (
            <select
              value={value}
              disabled={mod === 0}
              onChange={(e) => setter(e.target.value)}
            >
              {selectOptions[field]?.map((opt, idx) => (
                <option key={idx} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          ) : textFields.includes(field) ? (
            <input
              type="text"
              name={field}
              disabled={mod === 0}
              value={value}
              onChange={(e) => setter(e.target.value)}
            />
          ) : (
            <input
              type="number"
              name={field}
              disabled={mod === 0}
              value={value}
              onChange={(e) => {
                const str = e.target.value.trim();

                if (str === '') {
                  // prevent clearing: revert to current value
                  e.target.value = value;
                  return;
                }

                const num = Number(str);
                if (isNaN(num)) {
                  // prevent junk input like "abc"
                  e.target.value = value;
                  return;
                }

                setter(num);
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default SensorSettings;
